import { isBrowser } from '@/app/utils/browser';

export function getScrollbarWidth(): number {
  if (!isBrowser) return 0;

  const scrollDiv = document.createElement('div');

  scrollDiv.style.overflow = 'scroll';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '100px';
  scrollDiv.style.height = '100px';

  document.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);

  return scrollbarWidth;
}

export const hasScrollbar = (): boolean => {
  if (!isBrowser) return false;
  return document.documentElement.scrollHeight > window.innerHeight;
};
